import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './RunHeader.css'

interface RunHeaderProps {
  runName: string
  status: string
  errorMessage: string
  onDelete: () => void
}

function RunHeader({ runName, status, errorMessage, onDelete }: RunHeaderProps) {
  const navigate = useNavigate()
  const [confirmDelete, setConfirmDelete] = useState(false)

  const statusClass = status.toLowerCase().replace(/\s+/g, '-')

  function handleDelete() {
    onDelete()
    navigate('/runs')
  }

  return (
    <div data-testid="run-header" className="run-header">
      <Link data-testid="run-detail-back" to="/runs" className="run-header-back">&larr; Back to Runs</Link>
      <div className="run-header-top-row">
        <h1 className="run-header-title">Run Details: {runName}</h1>
        <span
          data-testid="run-status-badge"
          className={`run-header-status-badge ${statusClass}`}
        >
          {status.toUpperCase()}
        </span>
        <div className="run-header-spacer" />
      {!confirmDelete ? (
        <button
          data-testid="delete-run-btn"
          className="run-header-delete-btn"
          onClick={() => setConfirmDelete(true)}
        >
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4h12M5.33 4V2.67a1.33 1.33 0 011.34-1.34h2.66a1.33 1.33 0 011.34 1.34V4M12.67 4v9.33a1.33 1.33 0 01-1.34 1.34H4.67a1.33 1.33 0 01-1.34-1.34V4" /></svg>
          Delete Run
        </button>
      ) : (
        <div className="run-header-delete-confirm">
          <span className="run-header-delete-confirm-text">
            Delete this run?
          </span>
          <button
            data-testid="confirm-delete-run"
            className="run-header-delete-btn run-header-delete-btn-danger"
            onClick={handleDelete}
          >
            Confirm
          </button>
          <button
            data-testid="cancel-delete-run"
            className="run-header-delete-btn"
            onClick={() => setConfirmDelete(false)}
          >
            Cancel
          </button>
        </div>
      )}
      </div>
      {errorMessage && (
        <div data-testid="run-error-banner" className="run-header-error-banner">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="7" /><line x1="8" y1="5" x2="8" y2="8.5" /><circle cx="8" cy="11" r="0.5" fill="currentColor" /></svg>
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  )
}

export default RunHeader
